 /**
     *
     * @param state -
     * @param action -
     * @example
     * @returns
     */
 export const processResultToArray = (inputArray: Array<any>, media: string, agentName:string) => {
    const formattedArray: Array<any> = [];
    inputArray.forEach(item => {
        let messageFrom, startTimestamp, endTimestamp, message;
        
        if (media === 'Voice') {
            [messageFrom, startTimestamp, endTimestamp, message] = item.split("~");
            startTimestamp = parseInt(startTimestamp);
            endTimestamp = parseInt(endTimestamp);
        } else if (media === 'Digital') {
            [messageFrom, message] = item.split("~");
        }
        const formattedItem = {
            messageFrom: messageFrom?.toLowerCase(),
            // intermediateMsg: message,
            // postiveMsg: message,
            // negativeMsg: message,
            message: [message],
            agentName,
            card: '',
            startTime:startTimestamp,
            endTime:endTimestamp
        };
        formattedArray.push(formattedItem);
    });

    return formattedArray;
}

 /**
     *
     * @param state -
     * @param action -
     * @example
     * @returns
     */
 export const generateRandomId = (name1: string, name2: string) => {
    const currentDate = new Date();
    const dd = String(currentDate.getDate()).padStart(2, '0');
    const mm = String(currentDate.getMonth() + 1).padStart(2, '0');
    const hh = String(currentDate.getHours()).padStart(2, '0');
    const MM = String(currentDate.getMinutes()).padStart(2, '0');
    const generatedNumber = parseInt(dd + mm + hh + MM);
    return generatedNumber;
}